import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import App from '@Components/app';
import ModalContainerDeprecated from '@Components/modal-container-deprecated/modal-container';
import {ModalContainer} from '@Components/modal-container';
import {LoadingToast} from '@Components/loading-toast';
import {createRoot} from 'react-dom/client';
import {BEFORE_UNLOAD_EVENT, CACHE_KEY_FOR_SCHEDULING} from '@Libraries/social-media';
import {SocialMediaWizard} from '@/components/social-media-wizard';

function SocialMediaWizardApp(): ReactElement<any> | null {
  const [i18Loaded, setI18Loaded] = useState(false);

  const deletePrefilledDateCacheForScheduledPost = (): void => {
    window.PMW.deleteCacheItem(CACHE_KEY_FOR_SCHEDULING);
  };

  useEffect(() => {
    window.PMW.initI18next(window.PMW.LANGUAGE, () => {
      setI18Loaded(true);
    });

    window.addEventListener(BEFORE_UNLOAD_EVENT, deletePrefilledDateCacheForScheduledPost);

    return (): void => {
      window.removeEventListener(BEFORE_UNLOAD_EVENT, deletePrefilledDateCacheForScheduledPost);
    };
  }, []);

  if (!i18Loaded) {
    return <App />;
  }

  return (
    <App nonStrickModeChildren={<SocialMediaWizard {...window.reactPageProps} />}>
      <ModalContainerDeprecated />
      <ModalContainer />
      <LoadingToast />
    </App>
  );
}

const a = document.createElement('div');
a.setAttribute('id', 'pmw-app');
document.body.appendChild(a);

const root = createRoot(document.getElementById('pmw-app')!);
root.render(<SocialMediaWizardApp />);
